import metadata from "$public/metadata.json";
import { capitalize } from "$utils/capitalize";
export const taskTypeChoices = metadata.Task.taskType.type
    .sort()
    .map((id) => ({ id, name: capitalize(id).replaceAll("_", " ") }));
